import { render, staticRenderFns } from "./ProfileNotifications.vue?vue&type=template&id=5cfe0dff"
import script from "./ProfileNotifications.vue?vue&type=script&lang=js"
export * from "./ProfileNotifications.vue?vue&type=script&lang=js"
import style0 from "./ProfileNotifications.vue?vue&type=style&index=0&id=5cfe0dff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports